<!--  -->
<template>
  <div class='saleMsg_edit'>
    <div>
      <h2>欢迎注册嗨团商家</h2>
    </div>
    <el-form v-loading="loading" element-loading-text="正在上传..." label-width="100px" ref="form1" style="margin-top: 30px" :model="form" :rules="rules" size="medium" hide-required-asterisk>
      <el-form-item label="公司名称：" prop="companyName">
        <el-input placeholder="请输入公司名称" v-model="form.companyName" class="inp"></el-input>
      </el-form-item>
      <el-form-item label="联系人：" prop="contactsPerson">
        <el-input placeholder="请输入联系人姓名" v-model="form.contactsPerson" class="inp"></el-input>
      </el-form-item>
      <el-form-item label="手机号：" prop="phone">
        <el-input placeholder="请输入手机号" v-model="form.phone" class="inp"></el-input>
      </el-form-item>
      <el-form-item label="验证码：" prop="code">
        <div class="flexView" style="width: 95%">
          <el-input placeholder="请输入验证码" v-model="form.code" class="inp"></el-input>
          <el-button type="primary" :disabled="time > 0" style="margin-left: 5px" @click="getCode">{{time || '获取验证码'}}</el-button>
        </div>
      </el-form-item>
      <el-form-item label="密码：" prop="pwd">
        <el-input type="password" placeholder="请输入密码" v-model="form.pwd" class="inp"></el-input>
      </el-form-item>
      <el-form-item label="确认密码：" prop="repwd">
        <el-input type="password" placeholder="请输入确认密码" v-model="form.repwd" class="inp"></el-input>
      </el-form-item>
      <el-form-item label="职位：" prop="position">
        <el-input placeholder="请输入职位" v-model="form.position" class="inp"></el-input>
      </el-form-item>
      <div class="flexView">
        <el-form-item label="营业执照：" prop="businessPic">
          <div class="videoParent">
            <el-upload action="" v-if="!form.businessPic" :show-file-list="false" :http-request="uploadImg" multiple :accept="accept">
              <img src="@/assets/upload.png" @click="changeName('businessPic')" class="img" alt="">
            </el-upload>
            <div class="relativeDiv" v-else>
              <img src="@/assets/del.png" class="del" @click="delImg('businessPic')" alt="">
              <el-image :src="form.businessPic" class="img" fit="contain" :preview-src-list="[form.businessPic]" ></el-image>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="第二类医疗器械经营备案凭证：" prop="managePic">
          <div class="videoParent">
            <el-upload action="" v-if="!form.managePic" :show-file-list="false" :http-request="uploadImg" multiple :accept="accept">
              <img src="@/assets/upload.png" @click="changeName('managePic')" class="img" alt="">
            </el-upload>
            <div class="relativeDiv" v-else>
              <img src="@/assets/del.png" class="del" @click="delImg('managePic')" alt="">
              <el-image :src="form.managePic" class="img" fit="contain" :preview-src-list="[form.managePic]" ></el-image>
            </div>
          </div>
        </el-form-item>
      </div>
      <div class="flexView">
        <el-form-item label="医疗器械生产许可证：" prop="productionPic">
          <div class="videoParent">
            <el-upload action="" v-if="!form.productionPic" :show-file-list="false" :http-request="uploadImg" multiple :accept="accept">
              <img src="@/assets/upload.png" @click="changeName('productionPic')" class="img" alt="">
            </el-upload>
            <div class="relativeDiv" v-else>
              <img src="@/assets/del.png" class="del" @click="delImg('productionPic')" alt="">
              <el-image :src="form.productionPic" class="img" fit="contain" :preview-src-list="[form.productionPic]" ></el-image>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="医疗器械注册证：" prop="productPic">
          <div class="videoParent">
            <el-upload action="" v-if="!form.productPic" :show-file-list="false" :http-request="uploadImg" multiple :accept="accept">
              <img src="@/assets/upload.png" @click="changeName('productPic')" class="img" alt="">
            </el-upload>
            <div class="relativeDiv" v-else>
              <img src="@/assets/del.png" class="del" @click="delImg('productPic')" alt="">
              <el-image :src="form.productPic" class="img" fit="contain" :preview-src-list="[form.productPic]" ></el-image>
            </div>
          </div>
        </el-form-item>
      </div>
      <div>
        
        <el-form-item label="补充资料：">
          <div class="videoParent">
            <div class="fileList">
              <div class="relativeDiv" v-for="(item, i) in form.supplyLinks" :key="item">
                <img src="@/assets/del.png" class="del" @click="delImgList(i)" alt="">
                <el-image v-if="checkImg(item)" :src="item" class="img" fit="contain" :preview-src-list="form.supplyLinks" ></el-image>
                <div class="img" v-else>
                  <a :href="item" target="_blank">
                    <div>文件</div>
                    <div class="smallFont">（点击查看）</div>
                  </a>
                </div>
              </div>
              <el-upload action="" list-type="picture-card" :show-file-list="false" :http-request="uploadImgList" multiple>
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </div>
        </el-form-item>
      </div>
    </el-form>

    <div class="btmDiv">
      <el-button type="primary" @click="doSave" class="danger">立即注册</el-button>
    </div>
  </div>
</template>

<script>
import { checkImg } from "../utils/utils";
export default {
  components: {},
  data() {
    let validatePwd = (rules, val, callback) => {
      if(!val)return callback(new Error('请再次输入密码'))
      if(val !== this.form.pwd)return callback(new Error('两次输入密码不一致'))
      callback()
    }
    return {
      time: 0,
      name: '',
      loading: false,
      form: {
        phone: '',
        code: '',
        businessPic: '',
        managePic: '',
        productionPic: '',
        productPic: '',
        supplyLinks: [],
      },
      accept: '.jpg, .jpeg, .png',
      rules: {
        companyName: [{ required: true, message: '请输入公司名称', trigger: 'blur' },],
        contactsPerson: [{ required: true, message: '请输入联系人姓名', trigger: 'blur' },],
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' },],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' },],
        pwd: [{ required: true, message: '请输入密码', trigger: 'blur' },],
        repwd: [{ validator: validatePwd, trigger: 'blur' },],
        position: [{ required: true, message: '请输入职位', trigger: 'blur' },],
        businessPic: [{ required: true, message: '请上传营业执照', trigger: 'blur' },],
        managePic: [{ required: true, message: '请上传第二类医疗器械经营备案', trigger: 'blur' },],
        productionPic: [{ required: true, message: '请上传第二类医疗器械生产备案', trigger: 'blur' },],
        productPic: [{ required: true, message: '请上传第二类医疗器械产品备案', trigger: 'blur' },],
      },
    }
  },
  computed: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
  
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  methods: {
    doSave() {
      this.$refs.form1.validate(val => {
        console.log(val);
        if(!val)return
        this.$http.post('/api/WebUser/RegisterUser', this.form).then(() => {
          this.$message.success('注册成功')
          this.$emit('changeState')
        }).catch(() => {})
      })
    },
    checkImg,
    uploadImg(e) {
      this.loading = true
      let params = new FormData()
      params.append('file', e.file)
      this.$http.post('/api/WebUser/UploadFile', params).then(res => {
        this.form[this.name] = res.data.webUrl
      }).finally(() => {
        this.loading = false
      })
    },
    changeName(name) {
      this.name = name
    },
    delImg(name) {
      this.form[name] = ''
    },
    delImgList(i) {
      this.form.supplyLinks.splice(i, 1)
    },
    uploadImgList(e) {
      let params = new FormData()
      params.append('file', e.file)
      this.$http.post('/api/WebUser/UploadFile', params).then(res => {
        this.form.supplyLinks.push(res.data.webUrl)
      })
    },
    // 获取验证码
    getCode() {
      if(this.time > 0)return
      if(!this.form.phone)return this.$message.warning('请输入手机号')
      if(!/^1\d{10}$/.test(this.form.phone))return this.$message.warning('请输入正确的手机号')
      this.$http.get(`/api/WebUser/SendPhoneValidateCode?phoneNumber=${this.form.phone}`).then(() => {
        this.$message.success('验证码已发送')
        this.time = 60
        let interval = setInterval(() => {
          this.time--
          if(this.time <= 0) {
            clearInterval(interval)
            this.time = 0
          }
        }, 1000);
      })
    },
  },
}
</script>
<style lang="scss">
.saleMsg_edit {
  .el-upload--picture-card {
    width: 110px;
    height: 110px;
    line-height: 110px;
  }
}
</style>
<style lang='scss' scoped>
.saleMsg_edit {
  margin-top: 0px !important;
  > :first-child {
    display: flex;
    flex-direction: column;
    align-items: center;
    
    .loginLogo {
      height: 38px;
      width: auto;
      margin-bottom: 16px;
    }
  }
  .labelView {
    line-height: 18px;
    > :last-child {
      text-align: left;
      color: #999;
    }
  }
  .img {
    width: 110px;
    height: 110px;
    border-radius: 4px;
    text-align: center;
    border: 1px solid #f5f5f5;
  }
  .smallFont {
    color: #999;
    font-size: 12px;
  }
  .yanzhengma {
    width: 80px;
    text-align: center;
    background: lightblue;
  }
  .flexView {
    display: flex;
    > div {
      flex: 1;
    }
  }
  .fileList {
    display: flex;
    flex-wrap: wrap;
  }
  .relativeDiv {
    position: relative;
    width: 110px;
    margin-right: 10px;
    margin-bottom: 10px;
    a {
      text-decoration: none;
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 110px;
      line-height: 30px;
    }
    .del {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 10;
      width: 25px;
      cursor: pointer;
    }
  }
  .btmDiv {
    button {
      width: 80%;
      margin: 0 10%;
    }
  }
}
</style>